module.exports = __webpack_public_path__ + "static/media/img_panel_income.62febff4.jpg";